// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__AO3V+","light":"style_light__Da1CX","dark":"style_dark__beBrR"};